var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadInstruction1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#7BA0BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3332 21.3346H12.3332C11.3221 21.3346 10.4581 20.9846 9.74117 20.2846C9.02428 19.5846 8.66606 18.7291 8.6665 17.718C8.6665 16.8513 8.92762 16.0791 9.44984 15.4013C9.97206 14.7235 10.6554 14.2902 11.4998 14.1013C11.7776 13.0791 12.3332 12.2513 13.1665 11.618C13.9998 10.9846 14.9443 10.668 15.9998 10.668C17.2998 10.668 18.4027 11.1209 19.3085 12.0266C20.2143 12.9324 20.6669 14.0351 20.6665 15.3346C21.4332 15.4235 22.0694 15.7542 22.5752 16.3266C23.0809 16.8991 23.3336 17.5684 23.3332 18.3346C23.3332 19.168 23.0414 19.8764 22.4578 20.46C21.8743 21.0435 21.1661 21.3351 20.3332 21.3346H16.6665V16.568L17.7332 17.6013L18.6665 16.668L15.9998 14.0013L13.3332 16.668L14.2665 17.6013L15.3332 16.568V21.3346Z",
    fill: "#00225A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadInstruction1);
export default __webpack_public_path__ + "static/media/downloadInstruction1.748b13b75df1ab34776a612df874f08b.svg";
export { ForwardRef as ReactComponent };